import { FieldValues, FormState } from 'react-hook-form';

interface FieldErrorProps {
    formState: FormState<FieldValues>;
    fieldName: string;
}

const FieldError = ({ formState, fieldName }: FieldErrorProps) => {
    return formState.errors[fieldName] && <p className="form-error">{`${formState.errors[fieldName].message}`}</p>;
};

export default FieldError;
